import {
  EMAIL_BODY,
  EMAIL_LINK,
  EMAIL_SUBJECT,
  WHATSAPP_LINK,
} from "./mataMata.constants";
import { CTAType } from "./mataMata.types";

export const CTA_CONFIG: Record<
  CTAType,
  {
    open: () => void;
    openLabel: string;
    agreeLabel: string;
    cancelLabel: string;
  }
> = {
  whatsapp: {
    open: () => {
      window.open(WHATSAPP_LINK, "_blank", "noopener,noreferrer");
    },
    openLabel: "(not set)",
    agreeLabel: "sah dan setuju",
    cancelLabel: "batal",
  },
  email: {
    open: () => {
      window.location.href = `${EMAIL_LINK}?subject=${EMAIL_SUBJECT}&body=${EMAIL_BODY}`;
    },
    openLabel: "E-mel kami",
    agreeLabel: "E-mel kami::ok",
    cancelLabel: "E-mel kami::cancel",
  },
};
